import { omit, pick } from "radash";
import type { Pageable, PageQueryable } from "../types";

const ITEMS_PER_PAGE = 10;

export function offsetPage({ current, size }: Pageable) {
	const offsetPage = current ? Number(current) || 1 : 1;
	const offsetSize = size ? Number(size) || ITEMS_PER_PAGE : 10;
	const v = (offsetPage - 1) * offsetSize;
	return {
		skip: v,
		take: offsetSize ?? ITEMS_PER_PAGE,
	};
}

export function stripPage<T>(data: PageQueryable<T>): {
	page: Pageable;
	params: T;
} {
	const page = pick(data, ["current", "size"]) as Pageable;
	const params = omit(data, ["current", "size"]) as T;
	return { page, params };
}

export function isEmptyPage(count: number) {
	return count <= 0;
}

export function hasMorePage(count: number, page: number, size = 10): boolean {
	const pages = getPages(count, size);
	return page < pages;
}

export function getPages(count: number, size: number): number {
	if (!(count || size)) return 0;
	return Math.ceil(count / size);
}
